import { ChartData } from "chart.js";

export const getMyPageAcceptanceChart = (
  labels: string[],
  customersData: number[],
  officialRevenueData: number[],
  temporaryRevenueData: number[],
) => {
  return {
    labels: labels || [],
    datasets: [
      {
        type: "line" as const,
        label: "顧客数累計",
        data: customersData || [],
        borderColor: "#244540",
        backgroundColor: "#244540",
        borderWidth: 2,
      },
      {
        type: "bar" as const,
        label: "単月売上",
        data: officialRevenueData || [],
        yAxisID: "right-y-axis",
        backgroundColor: "#41C9B4",
        pointStyle: "rect",
        stack: "sales",
      },
      {
        type: "bar" as const,
        label: "単月売上見込",
        data: temporaryRevenueData || {},
        yAxisID: "right-y-axis",
        backgroundColor: "#D9D9D9",
        pointStyle: "rect",
        stack: "sales",
      },
    ],
  } as ChartData;
};

export const getMyPageSalesChart = (
  labels: string[],
  customersData: number[],
  revenueData: number[],
  futureRevenueData: number[],
) => {
  return {
    labels: labels || [],
    datasets: [
      {
        type: "line" as const,
        label: "顧客数累計",
        data: customersData || [],
        borderColor: "#244540",
        backgroundColor: "#244540",
        borderWidth: 2,
      },
      {
        type: "bar" as const,
        label: "単月売上",
        data: revenueData || [],
        yAxisID: "right-y-axis",
        backgroundColor: "#41C9B4",
        pointStyle: "rect",
        stack: "sales",
      },
      {
        type: "bar" as const,
        label: "単月売上見込",
        data: futureRevenueData || {},
        yAxisID: "right-y-axis",
        backgroundColor: "#D9D9D9",
        pointStyle: "rect",
        stack: "sales",
      },
    ],
  } as ChartData;
};
